import environmentVariables from '../app/environmentVariables';

/**
 * GET `/launch/network-stats` — public aggregate network stats for marketing.
 */
export async function getNetworkStats() {
    const res = await fetch(`${environmentVariables().REACT_APP_API_URL}/launch/network-stats`);
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
        throw new Error(data.error || 'Failed to load network stats');
    }
    return data;
}
